import React, { Component } from 'react';

import { HexAlphaColorPicker, HexColorInput } from "react-colorful";

class General extends Component {

    constructor(props) {
        super(props);
    }

    setColorsAndPreview = async (type, color) => {
        const { setColorsAndPreview } = this.props;
        await setColorsAndPreview('general', type, color);
    }
    
    setContainerBg = async (color) => {
        await this.setColorsAndPreview('containerBg', color);
    }

    render(){

        const { widget, handleInputChange, toggleColorPicker } = this.props;
        const { prorated } = widget.htmlData;

        return(

            <div className="mjwi-acc-panel-wrapper">

                <div className='mjwi-row'>
                    <div className='mjwi-col33'>
                        <label>Background</label>
                    </div>

                    <div className='mjwi-col66 mjwi-clr-picker'>

                        <span className="clrPickerVal" onClick={toggleColorPicker} style={{ backgroundColor: prorated.general.containerBg }}></span>
                        <HexAlphaColorPicker color={prorated.general.containerBg} onChange={this.setContainerBg} style={{display: "none"}} className="mjwi-apfl-color-picker" />
                        <HexColorInput color={prorated.general.containerBg} onChange={this.setContainerBg} />
                    </div>
                    </div>

            </div>
        );
    }
}

export default General;
